export default {
  populate: {
    localizations: true,
    facilities: {
      fields: ["id", "businessName"],
    },
  },
};
